import {
  ByIdReducerState,
  InvalidatedDatasets,
  ModelReducerState,
  TemplateBuilderReducerState,
} from "./types";
import { RootState as RS } from "../types";
import { EditRowWithColumns } from "../../requests/tableRowActions/types";

const getTemplateBuilderSlice = (state: RS): TemplateBuilderReducerState =>
  state.templateBuilder;

const templateBuilderByIds = (state: RS): ByIdReducerState =>
  getTemplateBuilderSlice(state).byId;

export const getTemplateBuilderById = (
  state: RS,
  id: number
): ModelReducerState | undefined => templateBuilderByIds(state)[id];

export const getStateChangedForId = (state: RS, id: number): boolean =>
  !!getTemplateBuilderById(state, id)?.stateChanged;

// ---------TEMPLATE-BUILDER-DATA---------------------------
export const getTemplateBuilderInvalidatedDatasetsForId = (
  s: RS,
  id: number
): InvalidatedDatasets | undefined =>
  getTemplateBuilderById(s, id)?.invalidatedDatasets;

export const getTemplateBuilderDataForId = (state: RS, id: number) =>
  getTemplateBuilderById(state, id)?.model.data;

export const getIsFetchingTemplateBuilderById = (
  state: RS,
  id: number
): boolean => !!getTemplateBuilderById(state, id)?.model?.isFetching;

export const getDataTemplateSlice = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.dataTemplate;

export const getPossibleItemTemplatesSlice = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.possibleItemTemplates;

export const getPossibleOverviewTemplates = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.possibleOverviewTemplates;

export const getPossibleDetailTemplates = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.possibleDetailTemplates;

export const getTables = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.tables;

export const getPossibleHegClasses = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.possibleHegClasses;

export const getPossibleHegFolders = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.possibleHegFolders;

export const getEmptyDataTableItem = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.emptyDataTemplateItem;

export const getAvailableDetailTemplates = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.availableDetailTemplates;

export const getPresentationTemplateSlice = (state: RS, id: number) =>
  getTemplateBuilderDataForId(state, id)?.presentationTemplate;

// ---------EDIT-ROW-DATA-----------------------------------
export const getTemplateBuilderEditRowForId = (
  state: RS,
  id: number
): EditRowWithColumns | undefined =>
  getTemplateBuilderById(state, id)?.editRow.data;

export const getEditRowIsFetchingById = (state: RS, id: number): boolean =>
  !!getTemplateBuilderById(state, id)?.editRow.isFetching;

export const getTemplateBuilderNameFromEditRowById = (
  state: RS,
  id: number
): string | undefined =>
  (getTemplateBuilderEditRowForId(state, id)?.row.cells.Name
    ?.value as string) || undefined;

// -----------SQL-QUERY-DATA---------------------------------
export const getSqlQueryForId = (state: RS, id: number): string | null =>
  getTemplateBuilderById(state, id)?.sqlQuery.data ?? null;

export const getSqlQueryIsFetching = (state: RS, id: number): boolean =>
  !!getTemplateBuilderById(state, id)?.sqlQuery.isFetching;
